import React, { Component, useState } from "react";
import {useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../../images/logo.png";
import BtnImg from "../../images/date.svg";
import UserProfile from "../../images/user.png";
import BtnImgEx from "../../images/Export-icon.svg";
import Button from 'react-bootstrap/Button';
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import swal from "sweetalert";
import axios from "axios";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function Header(props) {
  const token = localStorage.getItem("token");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [langActive, setLangActive] = useState(localStorage.getItem("selectLang"));
  const UserFName = localStorage.getItem("fname")
  const UserLName = localStorage.getItem("lname")
  const UserUimage = localStorage.getItem("nameImage")
  const [fullLoading, setFullLoading] = useState(false);
  const [dailyLoading, setDailyLoading] = useState(false);
  
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  // const onChange = (dates) => {
  //   const [start, end] = dates;    
  //   setStartDate(start);
  //   setEndDate(end);
  // };

  const changeLanguage = (event, param) => {
    //window.open('http://localhost/almanac/Almanac-D/ssss.xlsx', '_blank', 'noopener,noreferrer');
    console.log(event);
    console.log(param);
    setLangActive(param);
    localStorage.setItem("selectLang", param);

    const languageValue = param //event.target.value
    global.selLang = languageValue;
    i18n.changeLanguage(languageValue);
  }
  const downloadExcel = (event, param) => {
    console.log(param, 'AAAA');
    if(param == 'full') {
      setFullLoading(true)  
    }
    if(param == 'daily') {
      setDailyLoading(true)  
    }
    const st_date = startDate;
    const en_date = endDate;

    const s_date =  new Date(st_date);
    var e_date =  new Date(st_date);
    if(en_date != null){
      var e_date =  new Date(en_date);
    } 
    

    const phpSDate = s_date.getFullYear()+'-'+(s_date.getMonth()+1)+'-'+s_date.getDate();
    const phpEDate = e_date.getFullYear()+'-'+(e_date.getMonth()+1)+'-'+e_date.getDate();
    console.log(phpSDate, 'S_Date');
    console.log(phpEDate, 'E_Date');
    const postData = {sdate: phpSDate, edate: phpEDate, etype: param};
    
    axios.post(process.env.REACT_APP_API_KEY+"api/exportdata", postData,
    {headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      if(param == 'full') {
        setFullLoading(false)  
      }
      if(param == 'daily') {
        setDailyLoading(false)  
      }
      console.log('RES::', res);
      var reData = res.data; 
      if(reData.status == true){
        reData = reData.data; 
        if(reData.erro == false) {
          window.open(reData.url);
        } else {
          swal("Oops", reData.msg , "error");
        }
        console.log(reData.erro);
      } else {
        swal("Oops", "something went wrong please try again.", "error");
      }
    }).catch (error => {
      if(param == 'full') {
        setFullLoading(false)  
      }
      if(param == 'daily') {
        setDailyLoading(false)  
      }
      console.log('ERROR::');
      swal("Oops", "something went wrong please try again.", "error");
    });
  }
  const logout =() => {

    confirmAlert({
      title: "Confirm to log out",
        message: "Are you sure want to log out?",
        buttons:[
          {
            label: "Yes",
            onClick: () => {
              localStorage.removeItem("token")
              localStorage.removeItem("userData")
              localStorage.removeItem("fname")
              localStorage.removeItem("lname")
              localStorage.removeItem("nameImage")
              localStorage.removeItem("otpCounter")
              localStorage.removeItem("USERLOGIN")
              swal({
                title: "Log Out",
                text: "You have successfully logged out!",
                icon: "success",
                button: "OK",
              });
              navigate("/");
            } 
          },
          {
            label: "No",
            onClick: () => {},
          }
        ]

    })
 
  }
  document.body.onclick = function(e){
    const menu = document.querySelector('.navbar-collapse');
    const toggler = document.querySelector('.navbar-toggler');
      if((e.target !== menu && e.target.parentNode !== menu) && (e.target !== toggler && e.target.parentNode !== toggler)){
      if(menu.classList.contains('show')){
        toggler.click();
      }
    }
  }
  
  return (
    <>
      <div className="header">
            <Navbar bg="white" expand="lg">
                <Container>
                <Navbar.Brand href="#home"><img src={Logo} alt="Almanac logo" /></Navbar.Brand>
               <div className="d-flex sub-header">
               <div className="d-flex align-items-center">
               <div className="btn-box">                    
                    <button type="button" onClick={event => changeLanguage(event, 'en')}  className={(langActive == 'en') ? 'btn eng-btn active' : 'btn eng-btn'}>English</button>
                    <button type="button" onClick={event => changeLanguage(event, 'zh')} className={(langActive != 'en') ? 'btn chi-btn active' : 'btn chi-btn'}>华语</button>

                    </div>

                    <div className="header-dropdown">
                      <p>{UserFName} <br/> {UserLName}</p>
                      <p className="user-image">{UserUimage}</p>
                      <NavDropdown  id="basic-nav-dropdown">
                          <NavDropdown.Item href="change-password">Change Password</NavDropdown.Item>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                      </NavDropdown>
                    </div>
               </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto pr1">

        <DatePicker name="sdate" dateFormat = "dd/MM/yyyy" className = "header-datepicker " 
        selected={startDate}
        onChange={(date) => {
          setStartDate(date)
          if(date.getTime() >= endDate.getTime()){
            setEndDate(date)
          }
          console.log(date+' :A1Start: '+endDate);
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")}
      />
      <DatePicker name="sdate" dateFormat = "dd/MM/yyyy" className = "header-datepicker " 
        selected={endDate}
        onChange={(date) => {
          setEndDate(date)
          console.log('End: '+date);
        }}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        maxDate={new Date("12/31/2100")}
      />               
                    <Button variant="" className="nav-btn fill" title = "FULL SET Download" onClick={event => downloadExcel(event, 'full')} disabled = {fullLoading}>{fullLoading == true ? 'Wait...' : 'Full Set'}
                    <img src={BtnImgEx} alt="Date-img" />
                    </Button>
                    <Button variant="" className="nav-btn fill" title ="Daily Zodiac Download" onClick={event => downloadExcel(event, 'daily')} disabled = {dailyLoading}>{dailyLoading == true ? 'Wait...' : 'Daily Set'}
                    <img src={BtnImgEx} alt="Date-img" />
                    </Button>
                    
                    </Nav>
                </Navbar.Collapse>

               </div>
                </Container>
            </Navbar>
            
      </div>
    </>
  );
}

export default Header;
